$(document).ready(function(){
  var header_cookie = $.cookie('header_cookie');
  if(header_cookie == null || header_cookie == undefined ){
    $(".footer-announcement-text").show();
  }else{
    $(".footer-announcement-text").hide();
  }
  $('.notic-btn-link ,.close-cookie').click(function(){
    $(".footer-announcement-text").hide();
    $.cookie('header_cookie','yes',{expires:1, path:'/'});
  });
});


//  $(".site-nav--is-megamenu").hover(function(){
//    console.log(111111111111);
//    $('body').addClass('js-megamenu-open');
//  });


$(".site-nav--is-megamenu").mouseenter(function(){
  $('body').addClass('js-megamenu-open');
});
$(".site-nav--is-megamenu").mouseleave(function(){
  	$('body').removeClass('js-megamenu-open');
});


var p_height = $(".home_collection_slider .grid-product__content .grid-product__title");
var p_height2 = $(".second-featured-collection .grid-product__content .grid-product__title");
var p_height3 = $(".grid--collection .grid-product__title");
var p_height4 = $(".exto-arp-wrapper .arp-block__name");
var p_height5 = $(".wishlistpage .product .product_title");
var p_height6 = $(".grid--collection .grid-product__price");
var p_height7 = $(".second-featured-collection .grid-product .grid-product__image-mask");


$(document).ready(function(){
  var h1height = 0;
  var h2height = 0;
  var h3height = 0;
  var h4height = 0;
  var h5height = 0;
  var h6height = 0;
  var h7height = 0;
  p_height.each(function() {
    if(h1height < $(this).outerHeight()){
      h1height = $(this).outerHeight();
    };
  });
  p_height2.each(function() {
    if(h2height < $(this).outerHeight()){
      h2height = $(this).outerHeight();
    };
  });
  p_height3.each(function() {
    if(h3height < $(this).outerHeight()){
      h3height = $(this).outerHeight();
    };
  });
  p_height4.each(function() {
    if(h4height < $(this).outerHeight()){
      h4height = $(this).outerHeight();
    };
  });
  p_height5.each(function() {
    if(h5height < $(this).outerHeight()){
      h5height = $(this).outerHeight();
    };
  });
  p_height6.each(function() {
    if(h6height < $(this).outerHeight()){
      h6height = $(this).outerHeight();
    };
  });
  p_height7.each(function() {
    if(h7height < $(this).outerHeight()){
      h7height = $(this).outerHeight();
    };
  });
  p_height.css('min-height', h1height);
  p_height2.css('min-height', h2height);
  p_height3.css('min-height', h3height);
  p_height4.css('min-height', h4height);
  p_height5.css('min-height', h5height);
  p_height6.css('min-height', h6height);
  p_height7.css('min-height', h7height);
  
});

var width = $(window).innerWidth();

$(window).resize(function(){

  if ($(this).width() != width) {
    width = $(this).width();
    p_height.removeAttr('style');
    p_height2.removeAttr('style');
    p_height3.removeAttr('style');
    p_height4.removeAttr('style');
    p_height5.removeAttr('style');
    p_height6.removeAttr('style');
    p_height7.removeAttr('style');
    var h1height = 0;
    var h2height = 0;
    var h3height = 0;
    var h4height = 0;
    var h5height = 0;
    var h6height = 0;
    var h7height = 0;
    p_height.each(function() {
      if(h1height < $(this).outerHeight()){
        h1height = $(this).outerHeight();
      };
    });
    p_height2.each(function() {
      if(h2height < $(this).outerHeight()){
        h2height = $(this).outerHeight();
      };
    });
    p_height3.each(function() {
      if(h3height < $(this).outerHeight()){
        h3height = $(this).outerHeight();
      };
    });
    p_height4.each(function() {
      if(h4height < $(this).outerHeight()){
        h4height = $(this).outerHeight();
      };
    });
    p_height5.each(function() {
      if(h5height < $(this).outerHeight()){
        h5height = $(this).outerHeight();
      };
    });
    p_height6.each(function() {
      if(h6height < $(this).outerHeight()){
        h6height = $(this).outerHeight();
      };
    });
    p_height7.each(function() {
      if(h7height < $(this).outerHeight()){
        h7height = $(this).outerHeight();
      };
    });
  p_height.css('min-height', h1height);
  p_height2.css('min-height', h2height);
  p_height3.css('min-height', h3height);
  p_height4.css('min-height', h4height);
  p_height5.css('min-height', h5height);
  p_height6.css('min-height', h6height);
  p_height7.css('min-height', h7height);
  }
});

/*

$(document).ready(function(){
  var h2height = 0;
  p_height2.each(function() {
    if(h2height < $(this).outerHeight()){
      h2height = $(this).outerHeight();
    };
  });
  p_height2.css('min-height', h2height);
});

var width = $(window).innerWidth();

$(window).resize(function(){

  if ($(this).width() != width) {
    width = $(this).width();
    
    p_height2.removeAttr('style');
    
    var h2height = 0;
    p_height2.each(function() {
      if(h2height < $(this).outerHeight()){
        h2height = $(this).outerHeight();
      };
    });
    p_height2.css('min-height', h2height);
  }
});
*/

 $(document).ready(function() {
    $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  });


$(document).on('click','.bottom-add-to-cart',function(){
   $('.js-qty__num').val('1');
    $('.prod-add-to-cart').click();
})

$(document).ready(function() {
  setTimeout(function(){ 
    $('.arp-block__cart-button').attr('type','');
  }, 4000);

  if($('body').hasClass('template-search')){
    setTimeout(function(){
      if (window.location.href.indexOf("search?") > -1) {
        $('html,body').animate({
          scrollTop: $(".template-search #MainContent").offset().top
        }, 1);
      }
      else{
      }

    }, 300);
  }
});

  function restrictAlphabets(e){
    var x=e.which||e.keycode;
    if((x>=48 && x<=57) || x==8 ||
       (x>=35 && x<=40)|| x==46)
      return true;
    else
      return false;
  }


$(document).on('click','.prod_buy_now',function(){
$('.payment_buttons').find('.shopify-payment-button__button').click();
});
// $(document).on('click','.search_icon',function(){
//   window.location.replace('/search');
  
// });

$(document).on('click','.sticky-list .hamburger_btn',function(){
  $('.header-item .mobile-hamburger-icon .site-nav__link').click();
});
$(document).on('click','.sticky-list .currency_btn',function(){
  $('.header-item .mobile-hamburger-icon .site-nav__link').click();
  $('.currency_dropdown_1').addClass('open');
  setTimeout(function(){ 
//    $('.currency_dropdown_1').trigger('click');
    $('.drawer__inner').animate({
      scrollTop: $(".drawer__inner .currency_dropdown_1").offset().top
    }, 1);
  }, 1);
});



$(document).ready(function() {
  var distance = $('.header-sticky-wrapper').offset().top;

  $(window).on('scroll', function(){
    var scroll_position = $(window).scrollTop();

    if ($(window).scrollTop() >= distance ) {
      $(".sticky-list").css('transform','translateY(0%)');

    }else{
      $(".sticky-list").css('transform','translateY(100%)');
    }
    
  });
});

$(document).ready(function() {
  var collection = $('.collection-banner .banner-img').outerHeight() * 1.1; 
  if($(window).width() < 769){
  	 $('#shopify-section-collection-header').css('min-height', 'none');
  }
  else{
     $('#shopify-section-collection-header').css('min-height', collection);
  }
  

});

  $(window).resize(function(){
     var collection = $('.collection-banner .banner-img').outerHeight() * 1.1; 
    if($(window).width() < 769){
      $('#shopify-section-collection-header').css('min-height', 'none');
    }
    else{
      collection = $('.collection-banner .banner-img').outerHeight() * 1.1; 
      $('#shopify-section-collection-header').css('min-height', collection);
    }
  });




// $(window).bind('scroll', function() {
//     if($(window).scrollTop() >= $('.header-sticky-wrapper').offset().top) {
//         console.log('end reached');
//     }else{
//     console.log('top reached');
//     }
// });